module.exports = __webpack_public_path__ + "media/images/pages/careers-week/marcus-fd042badb2cdb535c07577931775b927.jpg";